import EventBus from './EventBus'
import SeatSelector from './SeatSelector'
import SeatSelectorFrame from './SeatSelectorFrame'
import SeatSelectorApi from './SeatSelectorApi'
/*
import Vue from 'vue'

Vue.config.devtools = true
Vue.config.performance = true
*/

window.EventBus = new EventBus()
window.Airobot = new function () {
  this.SeatSelector = SeatSelector
  this.SeatSelectorFrame = SeatSelectorFrame
  this.SeatSelectorApi = SeatSelectorApi
}()
window.axios = require('axios')



// WEBPACK FOOTER //
// ./src/main.js